export const getAttributeValue = (field, type) => {
  return field.attributes[type];
};
export const isOptionsArray = (value) => {
  return Array.isArray(value);
};
